import { deserialize, serializable } from 'serializr';
import { Base } from '../../../models/base.model';
import { PageObject } from '../../../models/page-object.model';

export class TestPlanResultSession extends Base implements PageObject {
  @serializable
  public executionRunId: number;

  @serializable
  public sessionId: string;

  @serializable
  public platformDeviceId: number;

  @serializable
  public deviceName: string;

  @serializable
  public sessionCreatedOn: Date;

  @serializable
  public sessionCompletedOn: Date;

  @serializable
  public deviceAllocatedOn: Date;

  @serializable
  public isExecutedOnBackupDevice: boolean;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestPlanResultSession, input));
  }
}
